export var MPADecision;
(function (MPADecision) {
    MPADecision["MPA_REVIEW_DECISION_APPROVED"] = "APPROVED";
    MPADecision["MPA_REVIEW_DECISION_DENIED"] = "DENIED";
    MPADecision["MPA_REVIEW_DECISION_CANCELLED"] = "CANCELLED";
})(MPADecision || (MPADecision = {}));
